/**
 * Normalizes a date to 'YYYY-MM-DD' string for consistent comparison.
 * Uses UTC methods to avoid timezone offset issues.
 */
export const toDateKey = (date: string | Date): string => {
  const d = new Date(date)
  const year = d.getUTCFullYear()
  const month = String(d.getUTCMonth() + 1).padStart(2, '0')
  const day = String(d.getUTCDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * Calculates accuracy between declared sales and ERP sales.
 * Formula: min(declared, erp) / max(declared, erp) * 100
 *
 * @returns accuracy percentage or null if no ERP data available
 */
export const calculateAccuracy = (
  declared: number,
  erpSales: number,
  hasErpData: boolean
): number | null => {
  if (!hasErpData) return null
  const maxVal = Math.max(declared, erpSales)
  if (maxVal <= 0) return null
  return (Math.min(declared, erpSales) / maxVal) * 100
}
